<ng-container *ngIf="!callback && !creating_callback">
	<div class="heading no-padding align-center">
		<h2>Arrange a callback</h2>
		<p>One of our sales staff will be in touch to take your payment.</p>
		<a
			class="button positive-button button-with-icon-right"
			data-element-click="button__engage_configure_reserve[telephone_payment]__positive-button[Arrange Callback]"
			(click)="showCallback()"
		>
			<i class="icon-callback"></i>
			<span class="text">Arrange Callback</span>
		</a>
	</div>
</ng-container>
<ng-container *ngIf="callback || creating_callback">
	<cng-callback-form [location]="'engage_configure_reserve[telephone_payment]'"></cng-callback-form>
</ng-container>
